<template>
    <div class="pill page-cont">
        <div class="pill-search">
            <el-input class="search-input" placeholder="请输入查询内容" clearable v-model.trim="searchWord"  />
            <div class="textarea-btn">
                <el-button type="primary" icon="el-icon-search" @click="search_click">查询</el-button> 
            </div>
        </div>
        <div class="pill-cont" v-loading="infoLoad">
            <p class="pill-tit" v-html="infoData.title"></p>
            <div class="cont">
                <div class="cont-details">
                    <p class="basic">基本信息</p>
                    <div class="info" v-for="(item,index) in infoData.rows" :key="index">
                        <div class="info-label">{{item.label}} </div>
                        <div class="info-txt" v-html="item.text"></div>
                    </div>
                        
                </div>
                <!-- <div class="cont-atlas">
                    <div class="atlas" ref="echarts_info"></div>
                    <div class="explain">
                        <p class="tit">相关概念</p>
                        <div class="explain-info">
                            <div class="label">技术类型</div>
                            <div class="txt">药方疗法</div>
                        </div>
                        <div class="explain-info">
                            <div class="label">疾病名称</div>
                            <div class="txt">脑梗塞脑梗塞脑梗塞脑梗塞</div>
                        </div>
                        <div class="explain-info">
                            <div class="label">治法</div>
                            <div class="txt">活血$化瘀$祛邪</div>
                        </div>
                    </div>
                </div> -->
            </div>
         </div>
    </div>
</template>

<script>
import {globalInfo} from '../io/api.js'
export default {
    data () {
        return {
            searchWord:this.$route.query.word||'',
            echartsInfo:'',
            infoLoad:false,
            infoData:{ },
            echartData:[
                {
                    "start_name": "大黄",
                    "start_id": "1566977305167",
                    "end_type": "名医",
                    "end_id": "1566978030108",
                    "end_name": "郭右陶",
                    "start_type": "中药",
                    "relation": "相关名医"
                },
                {
                    "start_name": "大黄",
                    "start_id": "1566977305167",
                    "end_type": "名医",
                    "end_id": "1566978057971",
                    "end_name": "程从周",
                    "start_type": "中药",
                    "relation": "相关名医"
                },
                {
                    "start_name": "大黄",
                    "start_id": "1566977305167",
                    "end_type": "名医",
                    "end_id": "1566977302816",
                    "end_name": "赵炳南",
                    "start_type": "中药",
                    "relation": "相关名医"
                },
                {
                    "start_name": "大黄",
                    "start_id": "1566977305167",
                    "end_type": "名医",
                    "end_id": "1566978056814",
                    "end_name": "陈匊生",
                    "start_type": "中药",
                    "relation": "相关名医"
                },
                {
                    "start_name": "大黄",
                    "start_id": "1566977305167",
                    "end_type": "名医",
                    "end_id": "1566978062426",
                    "end_name": "王三尊",
                    "start_type": "中药",
                    "relation": "相关名医"
                },
                {
                    "start_name": "大黄",
                    "start_id": "1566977305167",
                    "end_type": "名医",
                    "end_id": "1566978073572",
                    "end_name": "中神琴溪",
                    "start_type": "中药",
                    "relation": "相关名医"
                },
                {
                    "start_name": "大黄",
                    "start_id": "1566977305167",
                    "end_type": "名医",
                    "end_id": "1566978214647",
                    "end_name": "许琏",
                    "start_type": "中药",
                    "relation": "相关名医"
                },
                {
                    "start_name": "大黄",
                    "start_id": "1566977305167",
                    "end_type": "名医",
                    "end_id": "1566978028987",
                    "end_name": "王孟英",
                    "start_type": "中药",
                    "relation": "相关名医"
                },
                {
                    "start_name": "大黄",
                    "start_id": "1566977305167",
                    "end_type": "名医",
                    "end_id": "1566978047699",
                    "end_name": "王堉",
                    "start_type": "中药",
                    "relation": "相关名医"
                },
                {
                    "start_name": "大黄",
                    "start_id": "1566977305167",
                    "end_type": "名医",
                    "end_id": "1566978037891",
                    "end_name": "萧伯章",
                    "start_type": "中药",
                    "relation": "相关名医"
                }
            ],
            globalRow:{},
        }
    },
    created () {
        //从localStorage取出入参
        const globalRowStr = window.localStorage.getItem('globalRow');
        this.globalRow = globalRowStr ? JSON.parse(globalRowStr) : {};
    },
    mounted () {
        //图谱
        // this.echartsInfo = this.$echarts.init(this.$refs.echarts_info,); 
        // this.getEchart();

        
        this.$nextTick(()=>{
            this.getInfo();
        })
    },
    methods: { 
        getInfo(){ 
            this.infoLoad=true;
            let params={
                id: this.globalRow.Tid||'',
                link: this.globalRow.link||'',
                table: this.globalRow.table||'',
                searchWord:this.searchWord,//this.globalRow.chi_str_row||'',
            }
            globalInfo(params).then(res=>{
                let{code,data,msg}=res.data;
                if(code==0){
                    this.infoData=data;
                }else{
                    this.$message.error(msg||'请求失败～')
                }
                this.infoLoad=false;
            })
        },
        search_click(word){
            let query={
                word:this.searchWord,
            };
            // let url= this.$router.resolve({
            this.$router.push({
                path:'globalHotWord',
                query,
            }) 
            // this.$windowOpen({ url:url.href,isLogin:false} )
        },
        getEchart(){ 
            let _nodesArray = new Array();
            let _sourceArray = new Array();
            let startName='大黄'
            _nodesArray.push({category: 0, name: startName, value: 30,symbolSize:30});
            for (let i = 0; i < this.echartData.length; i++) {
                let rows = this.echartData[i]; 
                _nodesArray.push({category: 1, name: rows.end_name, value: 20,symbolSize:20});
                _sourceArray.push({
                    source: rows.end_name,
                    target: startName,
                    name: rows.relation,
                    relation: rows.relation
                });
                //source_json.push({source : json[i]['value'], target : data[0][table_row], weight :Math.ceil(Math.random()*10),relation: json[i]['property'],description:json[i]['description'],docs:json[i]['docs']});
            }
            let option = {
                /*title : {  // 标题
                text: '中医临床知识库知识图谱'
                },*/
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
                        if (params.data.relation) {
                            return params.data.relation;
                        } else {
                            return params.name;
                        }
                    }
                },
                series: [
                    {
                        type: 'graph', // 使用 graph 替代 force
                        layout: 'force', // 使用 force 布局算法
                        name: "知识图谱",  
                        ribbonType: false,
                        categories: [  // 节点分类
                            {
                                name: '0'  // 类目名称
                            },
                            {
                                name: '1'
                            },
                            {
                                name: '2'
                            },
                            {
                                name: '3'
                            }
                        ],
                        itemStyle: { // 图形样式
                            normal: { // 默认样式
                                label: { // 标签
                                    position: 'top',
                                    show: true,
                                    textStyle: {
                                        color: '#333'
                                    }
                                },
                                nodeStyle: {  // 节点样式
                                    brushType: 'both',
                                    borderColor: 'rgba(255,215,0,0.4)',
                                    borderWidth: 1
                                },
                                linkStyle: {  // 边的样式
                                    normal: {
                                        color: 'source',
                                        curveness: 0,
                                        type: "solid"
                                    }
                                }
                            }, 
                        }, 
                        data: _nodesArray,
                        edges: _sourceArray, 
                        // symbolSize: function (data) {
                        //     console.log(data,'=dd')
                        //     return data.value; // 根据节点的value值动态设置大小
                        // },
                        force: {
                            repulsion: 200, // 节点之间的斥力因子
                            edgeLength: [10, 60] // 边长的范围
                        }

                    }
                ]
            };
            console.log(_nodesArray,'_nodesArray')
            console.log(_sourceArray,'_sourceArray')
            // 为echarts对象加载数据
            this.echartsInfo.setOption(option);
            // window.onresize = echartsInfo.resize;
        }
        
    }
}
</script>
<style lang="less" scoped>
.pill{ 
    // padding:20px;
    .flex-space-between{
        display: flex;
        justify-content: space-between;
    }
    .pill-search{
        display: flex;
        justify-content: center;
        margin-bottom:20px;
        .search-input{
            width: 800px;
            margin-right:20px;
        }
    } 
    .pill-cont{  
        .pill-tit{
            font-weight: bold;
            margin-bottom: 10px;
            font-size: 24px;
        }
        .cont{
            .flex-space-between();
            line-height: 28px; 
            .cont-details{
                // flex-grow: 1;
                width:1200px;// 910px;
                border: 1px solid #dadada;
                border-bottom:none;
            }
            .cont-atlas{
                width:250px;
                .atlas,.explain{
                    width: 250px;
                    border: 1px solid #dadada;
                }
                .atlas{
                    height: 250px;
                    margin-bottom: 20px;
                }
                .explain{
                    background: #efefef;
                    padding:8px;
                    .tit{
                        font-weight: bold;
                    }
                    .explain-info{
                        .flex-space-between();
                        padding: 8px 0;
                        line-height: 20px;
                        border-top: 1px solid #dddddd;
                        .label{
                            width: 70px;
                        }
                        .txt{
                            width: 160px;
                        }
                    }
                } 
            }
        }
        .basic{
            background: #efefef;
            padding:0 10px;
            border-bottom: 1px solid #dadada;
            min-height: 28px; 
            padding:6px 10px;
            font-size: 16px;
            font-weight: bold
        }
        .info{
            .flex-space-between();
            padding:6px 10px;
            border-bottom: 1px solid #dadada;
            min-height: 28px; 
            .info-label{
                width: 150px;
                flex-shrink: 0;
                font-weight: bold
            }
            .info-txt{
                width: 1030px;//720px; 
            }
        }
    }
}
</style>
